export const HistoryEvent = {
  HistoryPageView: 'history_page_view',
  HistoryTypeClick: 'history_type_click',
} as const;

export interface HistoryDataType {
  [HistoryEvent.HistoryPageView]: {};
  [HistoryEvent.HistoryTypeClick]: { history_type: string };
}

export const HistoryEarnEvent = {
  DailyEarnCheckOpenClick: 'daily_earn_check_open_click',
  MonthlyEarnCheckOpenClick: 'monthly_earn_check_open_click',
} as const;

export interface HistoryEarnDataType {
  [HistoryEarnEvent.DailyEarnCheckOpenClick]: {
    date: string;
    daily_earning: number;
    apr_list: string[];
    list_order: number;
    currency: string;
  };
  [HistoryEarnEvent.MonthlyEarnCheckOpenClick]: {
    year: number;
    month: string;
    monthly_earning: number;
    list_order: number;
    currency: string;
  };
}

export const HistoryPositionEvent = {
  PositionHistoryPageView: 'position_history_page_view',
  PositionHistoryAllSymbolsClick: 'position_history_all_symbols_click',
  PositionHistoryCalendarClick: 'position_history_calendar_click',
  PositionHistoryRealizedPnlClick: 'position_history_realized_pnl_click',
  CalendarBottomSheetView: 'calendar_bottom_sheet_view',
  CalendarBottomSheetSearchClick: 'calendar_bottom_sheet_search_click',
  SelectSymbolAssetClick: 'select_symbol_asset_click',
} as const;

export interface HistoryPositionDataType {
  [HistoryPositionEvent.CalendarBottomSheetView]: { event_location: string };
  [HistoryPositionEvent.CalendarBottomSheetSearchClick]: {
    event_location: string;
    start_date: string;
    end_date: string; // 2024-02-02
  };
  [HistoryPositionEvent.SelectSymbolAssetClick]: { symbol: string };
  [HistoryPositionEvent.PositionHistoryRealizedPnlClick]: {
    position_id: string;
    symbol: string;
    realized_pnl: number;
    side: string;
    leverage: number;
  };
}

export const HistoryLaunchpoolEvent = {
  StakeHistoryDetailClick: 'stake_history_detail_click',
} as const;

export interface HistoryLaunchpoolDataType {
  [HistoryLaunchpoolEvent.StakeHistoryDetailClick]: { symbol: string; date: Date | null; stake_amount: string };
}

export const HistoryDepositEvent = {
  DepositHistoryTradeClick: 'deposit_history_trade_click',
  DepositHistoryConvertClick: 'deposit_history_convert_click',
} as const;

export interface HistoryDepositDataType {
  [HistoryDepositEvent.DepositHistoryTradeClick]: {
    deposit_amount: number;
    deposit_completed_ts: string;
    is_webview: boolean;
  };
  [HistoryDepositEvent.DepositHistoryConvertClick]: {
    deposit_amount: number;
    deposit_completed_ts: string;
    currency: string;
    is_webview: boolean;
  };
}
